import styled, { css } from 'styled-components';
import { useState, useEffect } from 'react';
import { useSelector } from 'src/store/store';

import { QuestionListItem } from 'src/modules/profileSurvey/components/sharedStyles';
import { text } from 'styles-js/mixins/typography';
import { Poll } from 'src/constants/types';

type answerProps = {
  id: string;
  title: string;
  votes: number;
  selectedChoices: string[];
  setSelectedChoices: (selectedChoices: string[]) => void;
}

export default function PollAnswer({ id, title, selectedChoices, setSelectedChoices }: answerProps): JSX.Element {
  const { isSingleAnswer } = useSelector((state) => state.pages.singlePost.post as Poll);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (checked) {
      if (isSingleAnswer) {
        setSelectedChoices([id]);
      } else {
        setSelectedChoices([...selectedChoices, id]);
      }
    } else {
      setSelectedChoices(selectedChoices.filter(c => c !== id));
    }
  }, [checked]);

  useEffect(() => {
    setChecked(selectedChoices.some(c => c === id));
  }, [selectedChoices]);

  return (
    <Answer checked={checked}>
      <TickBox
        checked={checked}
        name="poll"
        type={isSingleAnswer ? 'radio' : 'checkbox'}
        onChange={() => setChecked(!checked)}
      />
      <Title>{title}</Title>
    </Answer>
  );
}

const Answer = styled(QuestionListItem)<{ checked: boolean }>`
  ${text};
  min-height: 60px;
  height: auto;
  padding: 10px 10px 10px 0;
  ${({ checked }) => checked && css`
    background-color: ${({ theme }) => theme.colorBlueBackground};
  `};
  @media (${({ theme }) => theme.underScreenXxsmall}) {
    height: auto;
  }
`;
const TickBox = styled.input`
  cursor: pointer;
  margin: 0 10px 0 15px;
`;
const Title = styled.span`
  word-wrap: break-word;
`;
